"use client";

import { Pie, PieChart } from "recharts";
import { Box } from "@/components/ui/box";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";

export interface PieChartItem {
  fill?: string; // optional
  [key: string]: string | number | undefined;
}

interface PieChartSimpleProps {
  data: PieChartItem[];
  dataKey: string;
  nameKey: string;
  config?: ChartConfig;
  height?: number; // opsional
}

export function PieChartSimple({
  data,
  dataKey,
  nameKey,
  config,
  height = 250,
}: PieChartSimpleProps) {
  // Jika config tidak dikirim, buat otomatis dari data
  const autoConfig: ChartConfig = config
    ? config
    : Object.fromEntries(
        data.map((item) => [
          item[nameKey] as string,
          { color: item.fill || "#1F9545", label: item[nameKey] },
        ])
      );

  return (
    <ChartContainer
      config={autoConfig}
      className={`mx-auto w-full mt-4`}
      style={{ height }}
    >
      <PieChart>
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent hideLabel />}
        />
        <Pie
          data={data}
          dataKey={dataKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          outerRadius="100%"
        />
      </PieChart>
    </ChartContainer>
  );
}
